import * as S from './styles'
import { useContext, useEffect } from 'react'
import { defexCategories } from "../../Templates/defexData"
import { DefexContext } from '../../../context/DefexContext/DefexContext'
import Select from 'react-select'

const DefexMenu = () => {
    const { selectedTags, setSelectedTags } = useContext(DefexContext)

    useEffect(() => {
        // console.log(selectedTags)
    }, [selectedTags])

    const handleChange = (selectedOptions: any) => {
        setSelectedTags(selectedOptions)
    }

    return (
        <S.DefexMenuStyled>
            {
                defexCategories.map((c: any, ci: number) => {
                    let options = c.tags.map((t: any) => {
                        return {
                            value: t.value,
                            label: t.label
                        }
                    })

                    return (
                        <div className='category' key={ci}>
                            <h4>{c.type}</h4>
                            <Select className='category-select' isMulti options={options} onChange={handleChange} />
                        </div>
                    )
                })
            }
        </S.DefexMenuStyled>
    )
}

export default DefexMenu
